// Libellés, tons et petites règles des écrans des interventions.
import { LIBELLES_ETAT_INTERVENTION, LIBELLES_ETAT_MISSION, LIBELLES_QUALIFICATION, LIBELLES_TYPE_RAPPORT, PRIORITES_INTERVENTION } from '@cc/contrats';
import type { TonEtat } from '@cc/ui';
import type { EtatIntervention, EtatMission, PrioriteIntervention, QualificationSignalement } from './types';

export const TON_ETAT_INTERVENTION: Record<EtatIntervention, TonEtat> = {
  nouvelle: 'attente',
  planifiee: 'neutre',
  en_cours: 'signer',
  a_valider: 'attente',
  validee: 'ok',
  cloturee: 'ok',
  annulee: 'retard',
};

export const TON_QUALIFICATION: Record<QualificationSignalement, TonEtat> = {
  a_qualifier: 'attente',
  recevable: 'ok',
  oriente: 'neutre',
  rejete: 'retard',
  doublon: 'neutre',
};

export const TON_ETAT_MISSION: Record<EtatMission, TonEtat> = {
  affectee: 'attente',
  en_cours: 'signer',
  rapport_recu: 'ok',
  conflit: 'retard',
  validee: 'ok',
  annulee: 'retard',
};

export const TON_PRIORITE: Record<PrioriteIntervention, TonEtat> = { basse: 'neutre', normale: 'neutre', haute: 'attente', urgente: 'retard' };

export const libelleEtatIntervention = (e: string) => LIBELLES_ETAT_INTERVENTION[e as EtatIntervention] ?? e;
export const libelleEtatMission = (e: string) => LIBELLES_ETAT_MISSION[e as EtatMission] ?? e;
export const libelleQualification = (q: string) => LIBELLES_QUALIFICATION[q as QualificationSignalement] ?? q;
export const libellePriorite = (p: string) => PRIORITES_INTERVENTION[p as PrioriteIntervention] ?? p;
export const libelleTypeRapport = (t: string) => LIBELLES_TYPE_RAPPORT[t as keyof typeof LIBELLES_TYPE_RAPPORT] ?? t;

export const LIBELLES_AUTEUR: Record<string, string> = { usager: 'Portail citoyen', agent: 'Agent', guichet: 'Guichet' };

export const LIBELLES_TRANSITION: Record<string, { bouton: string; variante: 'principal' | 'secondaire' | 'danger'; motif: boolean; champ?: 'planifiee_le' | 'cout_reel' }> = {
  planifier: { bouton: 'Planifier', variante: 'principal', motif: false, champ: 'planifiee_le' },
  commencer: { bouton: 'Commencer les travaux', variante: 'secondaire', motif: false },
  soumettre: { bouton: 'Soumettre à validation', variante: 'secondaire', motif: false },
  refuser: { bouton: 'Refuser la validation', variante: 'danger', motif: true },
  valider: { bouton: 'Valider les travaux', variante: 'principal', motif: false },
  cloturer: { bouton: 'Clôturer', variante: 'principal', motif: false, champ: 'cout_reel' },
  annuler: { bouton: 'Annuler l\'intervention', variante: 'danger', motif: true },
};

export function montant(v: number | null | undefined): string {
  return v === null || v === undefined ? 'non renseigné' : `${v.toLocaleString('fr-FR')} F`;
}

export function duree(minutes: number | undefined): string {
  if (minutes === undefined) return 'non renseignée';
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return h > 0 ? `${h} h${m ? ` ${String(m).padStart(2, '0')}` : ''}` : `${m} min`;
}

export function aujourdhuiIso(): string {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}
